'use strict';

var DetailsLengthOfStayRenderersFactory = function DetailsLengthOfStayRenderersFactory($interpolate) {
  var availIcon = {
    "true": $interpolate(require('../templates/icon-available.html')),
    "false": $interpolate(require('../templates/icon-unavailable.html'))
  };
  var availabilityRenderer = function availabilityRenderer(row, columnfield, value, defaultvalue) {
    return defaultvalue.replace('>' + value + '<', '>' + availIcon[value]() + '<');
  };
  return {
    availabilityRenderer: availabilityRenderer
  };
};
DetailsLengthOfStayRenderersFactory.$inject = ['$interpolate'];
module.exports = DetailsLengthOfStayRenderersFactory;